import { render, staticRenderFns } from "./ModalAnswersRejected.vue?vue&type=template&id=2417ff07"
import script from "./ModalAnswersRejected.vue?vue&type=script&lang=js"
export * from "./ModalAnswersRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports